import { Component } from '@angular/core';

@Component({
    selector: 'dp-custom-header',
    template: ` <ng-content></ng-content>`,
})
export class HeaderInjectorComponent {}
